export enum SideBarType {
  Register,
  Upgrade,
  Upsell
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/enums/side-bar-type.ts